/**
 * @description 업무 예약 내역 > 날짜/기간 검색 분류 키워드 (dateType)
 */
export enum SearchDateTypeE {
    /** 결제일 */
    'PAYMENT' = 'PAYMENT',
    /** 입실일 */
    'CHECKIN' = 'CHECKIN',
    /** 퇴실일 */
    'CHECKOUT' = 'CHECKOUT',
}

/**
 * @description 업무 예약 내역 > 날짜/기간 검색 분류 타입
 */
export type SearchDateTypeT = keyof typeof SearchDateTypeE;

/**
 * @description 업무 예약 내역 > 검색어 분류 키워드 (keywordType)
 */
export enum KeywordTypeE {
    /** 예약번호 */
    'ORDER_ID' = 'ORDER_ID',
    /** 이메일 주소 */
    'EMAIL' = 'EMAIL',
    /** 회원명 */
    'USER_NAME' = 'USER_NAME',
    /** 제휴점명 */
    'FACILITY_NAME' = 'FACILITY_NAME',
    /** 그룹 */
    'DEPARTMENT_ID' = 'DEPARTMENT_ID',
    /** 직급 또는 직위 */
    'JOB_POSITION_NAME' = 'JOB_POSITION_NAME',
    /** 예약자명 */
    'RESERVATION_NAME' = 'RESERVATION_NAME',
    /** 예약자 휴대폰 번호 */
    'RESERVATION_PHONE_NUMBER' = 'RESERVATION_PHONE_NUMBER',
}

/**
 * @description 업무 예약 내역 > 검색어 분류 타입
 */
export type KeywordTypeT = keyof typeof KeywordTypeE;

// 이전 버전 호환용
export type SearchTypeT = KeywordTypeT;
export const SearchTypeE = KeywordTypeE;

/**
 * @description 업무 예약 내역 > 권역 분류 키워드 (stayType)
 */
export enum StayTypeE {
    /** 국내 */
    'INSTAY' = 'INSTAY',
    /** 해외 */
    'EXSTAY' = 'EXSTAY',
}

/**
 * @description 업무 예약 내역 > 권역 분류 타입
 */
export type StayTypeT = keyof typeof StayTypeE;

// 이전 버전 호환용
export type CategoryTypeT = StayTypeT;
export const CategoryTypeE = StayTypeE;
export type RegionTypeT = StayTypeT;
export const RegionTypeE = StayTypeE;

/**
 * @description 업무 예약 내역 > 출장(예약) 상태 분류 키워드 (status)
 */
export enum ReservationStatusE {
    /** 예약완료 */
    'CONFIRM' = 'CONFIRM',
    /** 취소완료 */
    'CANCEL' = 'CANCEL',
    /** 이용완료 */
    'COMPLETE' = 'COMPLETE',
}

/**
 * @description 업무 예약 내역 > 출장(예약) 상태 분류 타입
 */
export type ReservationStatusT = keyof typeof ReservationStatusE;

// 이전 버전 호환용
export type TripStatusT = ReservationStatusT;
export const TripStatusE = ReservationStatusE;

/**
 * @description 업무 예약 내역 > 규정 준수 여부 분류 키워드 (businessTripPolicyCompliantStatus)
 */
export enum PolicyComplianceE {
    /** 준수 */
    'COMPLIANT' = 'COMPLIANT',
    /** 미준수 */
    'NON_COMPLIANT' = 'NON_COMPLIANT',
    /** 해당없음 */
    'UNSPECIFIED' = 'UNSPECIFIED',
}

/**
 * @description 업무 예약 내역 > 규정 준수 여부 분류 타입
 */
export type PolicyComplianceT = keyof typeof PolicyComplianceE;
